module.exports = __webpack_public_path__ + "@/assets/img/start.1382ea4d.svg";